import { Box, Button, CircularProgress, DialogActions, DialogContent, DialogTitle, Typography } from "@mui/material"
import ReactMarkdown from "react-markdown"
import { useAsync } from "lib/@hooks/useAsync"
import { sampleCopScan } from "./controller/sample-cop-scan.controller"
import { If, Else } from "lib/@components/switch"

export function CopSampleScanDialog({ codeOfPracticeId, sampleSize, cancel }) {
    const report = useAsync(runScan, null, [codeOfPracticeId, sampleSize])

    return (
        <>
            <DialogTitle>Sample Compliance Scan</DialogTitle>
            <If value={!report}>
                <DialogContent>
                    <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2, py: 6 }}>
                        <CircularProgress />
                        <Typography color="text.secondary">
                            Scanning {sampleSize ?? 10} random schedules — this may take a minute…
                        </Typography>
                    </Box>
                </DialogContent>
                <Else>
                    <DialogContent dividers>
                        <Box
                            sx={{
                                "& h1,& h2,& h3,& h4": { mt: 1.5, mb: 0.5 },
                                "& p": { mt: 0, mb: 1 },
                                "& ul,& ol": { pl: 2.5, mb: 1 },
                                "& li": { mb: 0.5 },
                                "& hr": { my: 1.5, borderColor: "divider" },
                            }}
                        >
                            <ReactMarkdown>{report}</ReactMarkdown>
                        </Box>
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={cancel}>Close</Button>
                    </DialogActions>
                </Else>
            </If>
        </>
    )

    async function runScan() {
        try {
            return await sampleCopScan({ codeOfPracticeId, sampleSize })
        } catch (e) {
            return `# Scan failed\n\n${e.message}`
        }
    }
}
